import React from "react";
import Select from "react-select";
import { getPublishers } from "../../helpers/Api";
import _ from "lodash";

const SUPER_USER_PUB = {
  pubId: 0,
  pubName: "Intowow Super User",
};

class PublisherSelector extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      options: [],
      selectedValue: null,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  async componentDidMount() {
    const { result } = await getPublishers();

    result.unshift(SUPER_USER_PUB);

    let options = _.map(result, (r) => {
      return {
        value: r.pubId,
        label: r.pubId + " - " + r.pubName,
      };
    });

    this.setState({
      options,
    });
  }

  handleChange(option) {
    this.setState({
      selectedValue: option,
    });

    this.props.handleOnChange({
      pubIds: _.map(option, (o) => {
        return o.value;
      }),
    });
  }

  render() {
    const { options, selectedValue } = this.state;

    return (
      <>
        <Select
          // className="w-24 z-50"
          value={selectedValue}
          onChange={this.handleChange}
          options={options}
          isMulti
        />
      </>
    );
  }
}

export default PublisherSelector;
